var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"align-center layout px-4 pt-4 app--page-header",attrs:{"row":""}},[_c('div',{staticClass:"page-header-left"},[_c('h3',{staticClass:"pr-3"},[_vm._v(_vm._s(this.$route.meta.title))])])])}
var staticRenderFns = []

export { render, staticRenderFns }